export default [
  {
    path: "/saiqe",
    children: [
        //students
      {
        path: "students",
        name: "saiqe-students",
        component: () =>
          import("../views/saiqe/students/index.vue"),
        meta: {
          title: "STUDENTS",
          authRequired: true,
          acc: 'y54282'
        },
      },
      {
        path: "studentslsi",
        name: "saiqeStudentsList",
        component: () => import("@/views/saiqe/students/list.vue"),
        meta: {
          title: "Students list",
          authRequired: true,
          acc: 'y54282'
        },
      },
      {
        path: "view-student/:id?",
        name: "saiqeStudent",
        component: () =>
          import("../views/saiqe/students/view.vue"),
        meta: {
          title: "VIEW STUDENT",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "edit-student/:id?",
        name: "saiqe-edit-student",
        component: () =>
          import(
            "../views/saiqe/students/components/edit.vue"
          ),
        meta: {
          title: "EDIT STUDENT",
        },
      },
      //register
      {
        path: "register",
        name: "saiqe-register",
        component: () =>
          import("../views/saiqe/register.vue"),
        meta: {
          title: "REGISTER",
        },
      },
      //Cas
      {
        path: "cas",
        name: "saiqe-cas",
        component: () =>
          import("../views/saiqe/cas/index.vue"),
        meta: {
          title: "SAIQE CAS",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "regcas/:id?",
        name: "saiqeWithCas",
        component: () =>
          import("../views/saiqe/cas/withca.vue"),
        meta: {
          title: "SAIQE REG CAS",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "nonreg/:id?",
        name: "saiqeWithoutCas",
        component: () =>
          import("../views/saiqe/cas/withoutca.vue"),
        meta: {
          title: "SAIQE NON REG CAS",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "editca/:id?",
        name: "saiqe-editca",
        component: () =>
          import("../views/saiqe/cas/edit.vue"),
        meta: {
          title: "SAIQE UPDATE CA",
          authRequired: true,
          acc: 'y37962'
        },
      },
      //photo album
      {
        path: "photo_album",
        name: "saiqe-photo_album",
        component: () =>
          import("../views/saiqe/photo-album.vue"),
        meta: {
          title: "PHOTO ALBUM",
        },
      },
      //gazette
      {
        path: "gazette",
        name: "saiqe-gazette",
        component: () =>
          import("../views/saiqe/gazette/index.vue"),
        meta: {
          title: "GAZETTE",
        },
      },
      //exam card
      {
        path: "exam-card",
        name: "saiqeStudentsExamcard",
        component: () =>
          import("../views/saiqe/exam-card.vue"),
        meta: {
          title: "EXAM CARD",
          authRequired: true,
          acc: 'y54282'
        },
      },
      //subject Analysis
      {
        path: "subject-analysis",
        name: "saiqe-subject-analysis",
        component: () =>
          import("../views/saiqe/subject-analysis.vue"),
        meta: {
          title: "SUBJECT ANALYSIS",
        },
      },
    ],
  },
];
